import React, {memo, useCallback, useState} from "react";
import {
  ColumnCenter,
  Button,
  InjectedModalProps,
  Text, ConfirmationPendingContent, TransactionErrorContent
  , useToast
} from "@pancakeswap/uikit";
import styled from "styled-components";
import Twitter from "@pancakeswap/uikit/src/components/Svg/Icons/Twitter";
import {useTranslation} from '@pancakeswap/localization';
import {isIOS, isAndroid} from 'react-device-detect';
import BigNumber from "bignumber.js";
import useCatchTxError from "hooks/useCatchTxError";
import {useDackieFaucetContract} from "hooks/useContract";
import {updateUserAllowance} from "state/pools";
import {useCallWithGasPrice} from "hooks/useCallWithGasPrice";
import ConfirmFaucetModalContainer from "./ConfirmFaucetModalContainer";
import {calculateGasMargin} from "../../utils";
import {useGasPrice} from "../../state/user/hooks";
import {TransactionSubmittedContent} from "../TransactionConfirmationModal";
import {ToastDescriptionWithTx} from "../Toast";
import {transactionErrorToUserReadableMessage} from "../../utils/transactionErrorToUserReadableMessage";


const Wrapper = styled.div`
  width: 100%;
`;

const ConfirmedIcon = styled(ColumnCenter)`
  padding: 34px 0;
`;

const TextWithToken = styled(Text)`
  align-items: center;
  display: flex;
  justify-content: center;
`

const ImgToken = styled.img`
  width: 24px;
  margin-right: 5px;
`

const retweetWebUrl = `https://twitter.com/intent/retweet?tweet_id=1666479269055176704`
const retweetAppUrl = 'twitter://status?id=1666479269055176704'


interface ConfirmSwapModalProps {
  chainId?: number
  account?: string
  isWrongNetwork?: boolean
}

const ConfirmFaucetModel: React.FC<React.PropsWithChildren<InjectedModalProps & ConfirmSwapModalProps>> = ({
                                                                                                             chainId,
                                                                                                             account,
                                                                                                             isWrongNetwork,
                                                                                                             onDismiss
                                                                                                           }) => {
  const faucetContract = useDackieFaucetContract()
  const gasPrice = useGasPrice()
  const {t} = useTranslation()
  const {toastSuccess} = useToast()
  const {fetchWithCatchTxError, loading: pendingTx} = useCatchTxError()
  const {callWithGasPrice} = useCallWithGasPrice()

  const [isConfirmTweet, setIsConfirmTweet] = useState(false)
  const [{attemptingTxn, errorMessage, txHash}, setFaucetState] = useState<{
    attemptingTxn: boolean
    errorMessage: string | undefined
    txHash: string | undefined
  }>({
    attemptingTxn: false,
    errorMessage: undefined,
    txHash: undefined
  })

  const onClickRetweet = (e) => {
    e.preventDefault();

    const width = 600;
    const height = 400;
    const left = (window.innerWidth / 2) - (width / 2);
    const top = (window.innerHeight / 2) - (height / 2);

    if (isIOS || isAndroid) {
      setTimeout(() => {
        window.location.assign(retweetAppUrl);
      }, 25);
    } else {
      window.open(retweetWebUrl, '_blank', `width=${width},height=${height},top=${top},left=${left}`);
    }

    setIsConfirmTweet(true)
  }

  const faucet = useCallback(async () => {
    if (!faucetContract) return
    const inputTimestamp = Math.round(Date.now() / 1000 - 12)
    const fee = new BigNumber(77 * 10 ** 14)
    setFaucetState({attemptingTxn: true, errorMessage: undefined, txHash: undefined})

    const receipt = await fetchWithCatchTxError(async () => {
      try {
        return await callWithGasPrice(faucetContract, 'claim', [inputTimestamp], {value: Number(fee)});
      } catch (error) {
        setFaucetState({
          attemptingTxn: false,
          errorMessage: t(transactionErrorToUserReadableMessage(error, t)),
          txHash: undefined
        })
      }
      return undefined
    })
    if (receipt?.status) {
      setFaucetState({attemptingTxn: false, errorMessage: undefined, txHash: receipt.transactionHash})
      toastSuccess(
        "Faucet Succeed!",
        <ToastDescriptionWithTx txHash={receipt.transactionHash}/>
      )
    }
  }, [faucetContract, fetchWithCatchTxError, callWithGasPrice, t, toastSuccess])

  return (
    <ConfirmFaucetModalContainer handleDismiss={onDismiss}>
      {attemptingTxn ? (
        <ConfirmationPendingContent/>
      ) : txHash ? (
        <>
          <TransactionSubmittedContent
            chainId={chainId}
            hash={txHash}
            onDismiss={onDismiss}
          />
        </>
      ) : !errorMessage ? (
        <>
          <Wrapper>
            <Text fontSize="20px" color="textSubtle" textAlign="center">
              Retweet this tweet to receive:
            </Text>
            <TextWithToken fontSize="20px" color="textSubtle" textAlign="center">
              <ImgToken width="24px"
                        src={`https://raw.githubusercontent.com/DackieSwap/dackieswap-tokens/main/images/${chainId}/tokens/0x2e9F75DF8839ff192Da27e977CD154FD1EAE03cf.png`}/> 300
              $USDC
            </TextWithToken>
            <TextWithToken fontSize="20px" color="textSubtle" textAlign="center">
              <ImgToken width="24px"
                        src={`https://raw.githubusercontent.com/DackieSwap/dackieswap-tokens/main/images/${chainId}/tokens/0x3e8B7c72f4a9f4C8ec375c11F44FB84242c3893F.png`}/> 300
              $USDT
            </TextWithToken>
            <TextWithToken fontSize="20px" color="textSubtle" textAlign="center">
              <ImgToken width="24px"
                        src={`https://raw.githubusercontent.com/DackieSwap/dackieswap-tokens/main/images/${chainId}/tokens/0xeA96c24CDeF2FB472b86eB51414e8D7cf2cA3302.png`}/> 0.0002
              $WBTC
            </TextWithToken>
            <ConfirmedIcon>
              {!isConfirmTweet ? (
                <>
                  <Button onClick={onClickRetweet} endIcon={<Twitter color="#ffffff"/>}>
                    Twitter
                  </Button>
                </>
              ) : (
                <>
                  <Button disabled={(!account || isWrongNetwork)}
                          onClick={faucet}>
                    Faucet
                  </Button>
                </>
              )}
            </ConfirmedIcon>
          </Wrapper>
        </>
      ) : <TransactionErrorContent onDismiss={onDismiss} message={errorMessage}/>
      }
    </ConfirmFaucetModalContainer>
  )
}

export default memo(ConfirmFaucetModel)
